import { useRef, useMemo, useEffect } from 'react';
import _ from 'lodash';

type refCallback = () => void;

const useDebounce = (callback: refCallback): refCallback => {
  const ref = useRef<refCallback | null>(null);

  useEffect(() => {
    ref.current = callback;
  }, [callback]);

  const debouncedCallback = useMemo(() => {
    const func = () => {
      ref.current?.();
    };

    return _.debounce(func, 300);
  }, []);

  return debouncedCallback;
};

export default useDebounce;
